const ua = window.navigator.userAgent
const androidAppREG = /kflower\.driver.*_(.+)_\d+.*/ig
const iosAppREG = /kflowerudriver.*_(\d+\.\d+\.\d+).*/ig
const androidApp = androidAppREG.exec(ua) || ''
const iOSApp = iosAppREG.exec(ua) || ''
const isAndroidApp = !!androidApp
const isIOSApp = !!iOSApp
const isApp = isAndroidApp || isIOSApp || false
const appVersion = androidApp[1] || iOSApp[1] || ''

export default {
    isApp,
    isIOSApp,
    isAndroidApp,
    appVersion
}
